import request from '@/utils/request'
const sign = () => {
    return request({
        url: '/logout',
        method: 'POST'
    })
}

const categoryAdd = data => {
    return request({
        url: '/category/add',
        method: 'POST',
        data
    })
}
const categoryEdit = data => {
    return request({
        url: '/category/edit',
        method: 'POST',
        data
    })
}

const categoryDele = query => {
    return request({
        url: '/category/remove',
        method: 'GET',
        params: query
    })
}
const muralAdd = data => {
    return request({
        url: '/mural/add',
        method: 'POST',
        data
    })
}
const muralEdit = data => {
    return request({
        url: '/mural/edit',
        method: 'POST',
        data
    })
}
const muralDele = query => {
    return request({
        url: '/mural/remove',
        method: 'GET',
        params: query
    })
}
const imgList = query => {
    return request({
        url: '/mural/item',
        method: 'GET',
        params: query
    })
}
const imgAdd = data => {
    return request({
        url: '/mural/item/add',
        method: 'POST',
        data
    })
}
const imgEdit = data => {
    return request({
        url: '/mural/item/edit',
        method: 'POST',
        data
    })
}
const imgDele = query => {
    return request({
        url: '/mural/item/remove',
        method: 'GET',
        params: query
    })
}
export {
    sign,
    categoryAdd,
    categoryEdit,
    categoryDele,
    muralAdd,
    muralEdit,
    muralDele,
    imgList,
    imgAdd,
    imgEdit,
    imgDele
}


// WEBPACK FOOTER //
// ./src/api/interface/admin.js